
































import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import NewsForm from '@/modules/news/components/admin/NewsForm.vue'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import { mixins } from 'vue-class-component'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import AdminPredefinedAnswerForm from '@/modules/predefined-answer/components/admin/AdminPredefinedAnswerForm.vue'
import { FaqUpdateUseCase } from '@/modules/faq/use-cases/admin/faq-update-use.case'
import AdminFaqForm from '@/modules/faq/components/admin/AdminFaqForm.vue'
import { FaqCollectionModel, FaqCollectionWithModel } from '@/modules/faq/models/faq-collection.model'

@Component({
  components: { AdminFaqForm, AdminPredefinedAnswerForm, Modal, NewsForm, BaseButton }
})
export default class AdminFaqUpdateDialog extends mixins<DialogMixin>(DialogMixin) {
  constructor(
    private readonly useCase: FaqUpdateUseCase
  ) {
    super()
  }

  $refs: {
    dialog: QDialog
  }

  @Prop() faq!: FaqCollectionModel
  @Prop() withData!: FaqCollectionWithModel
  private editBtnLabel: string = 'ذخیره تغییرات'
  private editCancelBtnLabel: string = 'انصراف'
  private dialogModel = true

  onSubmit() {
    this.useCase.execute(this.faq.id, this.faq).then(() => {
      if (this.useCase.isSuccess) this.dialogModel = false
    })
  }

}
